import { useThemeStore } from "../../stores/ThemeStore";

const LimitReachedIllustration = () => {
  const theme = useThemeStore((s) => s.theme);
  const mainColor = theme.colors.secondary[6];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 600.79951 615.14711"
    >
      <polygon
        points="377.647 583.021 359.46 614.521 395.833 614.521 377.647 583.021 359.46 614.521 395.833 614.521 377.647 583.021"
        fill="#f2f2f2"
      />
      <path
        d="M630.74677,300.69743v86.41a8.85568,8.85568,0,0,1-8.84,8.84h-66.28l.61-.78c34.87-23.28,59.58-54.34,73.73-93.48Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#f2f2f2"
      />
      <path
        d="M697.91024,214.63666h-375.62a22.71741,22.71741,0,0,0-22.69,22.69v225.62a22.71741,22.71741,0,0,0,22.69,22.69h375.62a22.71738,22.71738,0,0,0,22.69-22.69v-225.62A22.71738,22.71738,0,0,0,697.91024,214.63666Zm20.69,248.31a20.68584,20.68584,0,0,1-20.69,20.69h-375.62a20.68588,20.68588,0,0,1-20.69-20.69v-90.63q0-7.92.77-15.65a155.598,155.598,0,0,1,154.91-140.03H697.91024a20.69225,20.69225,0,0,1,20.69,20.69Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#e6e6e6"
      />
      <path
        d="M577.95028,319.84669h-195.37a6.035,6.035,0,1,0,0,12.07h195.37a6.035,6.035,0,0,0,0-12.07Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#e6e6e6"
      />
      <path
        d="M443.1503,285.99671h-60.57a6.04,6.04,0,1,0,0,12.08h60.57a6.04,6.04,0,0,0,0-12.08Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#e6e6e6"
      />
      <path
        d="M382.58029,319.84669h29.95a112.86666,112.86666,0,0,1-12.28,12.07h-17.67a6.035,6.035,0,1,1,0-12.07Z"
        transform="translate(-299.60025 -142.42645)"
        fill={mainColor}
      />
      <path
        d="M382.58029,285.99671h50.55a111.07119,111.07119,0,0,1-5.57,12.08h-44.98a6.04,6.04,0,1,1,0-12.08Z"
        transform="translate(-299.60025 -142.42645)"
        fill={mainColor}
      />
      <path
        d="M437.98025,217.82667a155.75305,155.75305,0,0,0-135.61,138.84c-.93-.18-1.85-.39-2.77-.61v-118.73a22.71741,22.71741,0,0,1,22.69-22.69h114.89C437.47024,215.68665,437.73025,216.75666,437.98025,217.82667Z"
        transform="translate(-299.60025 -142.42645)"
        fill={mainColor}
      />
      <circle cx="137.24921" cy="74.12161" r="18.88733" fill="#fff" />
      <path
        d="M436.84939,236.43531A19.88721,19.88721,0,1,1,456.7366,216.5481,19.90976,19.90976,0,0,1,436.84939,236.43531Zm0-37.77442A17.88721,17.88721,0,1,0,454.7366,216.5481,17.90715,17.90715,0,0,0,436.84939,198.66089Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#3f3d56"
      />
      <path
        d="M434.27283,226.378a2.10034,2.10034,0,0,1-1.68059-.84056l-5.15275-6.87045a2.10091,2.10091,0,1,1,3.36153-2.521l3.37111,4.49447,8.65825-12.98721a2.101,2.101,0,0,1,3.49627,2.33085l-10.30551,15.45826a2.10186,2.10186,0,0,1-1.68983.93493Z"
        transform="translate(-299.60025 -142.42645)"
        fill={mainColor}
      />
      <circle cx="286.24921" cy="207.12161" r="18.88733" fill="#fff" />
      <path
        d="M585.84939,369.43531A19.88721,19.88721,0,1,1,605.7366,349.5481,19.90976,19.90976,0,0,1,585.84939,369.43531Zm0-37.77442A17.88721,17.88721,0,1,0,603.7366,349.5481,17.90715,17.90715,0,0,0,585.84939,331.66089Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#e6e6e6"
      />
      <path
        d="M583.27283,359.378a2.10034,2.10034,0,0,1-1.68059-.84056l-5.15275-6.87045a2.10091,2.10091,0,1,1,3.36153-2.521l3.37111,4.49447,8.65825-12.98721a2.101,2.101,0,0,1,3.49627,2.33085l-10.30551,15.45826a2.10186,2.10186,0,0,1-1.68983.93493Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#e6e6e6"
      />
      <path
        d="M534.97385,151.76506a48.47181,48.47181,0,0,0-28.736-9.33845,47.80451,47.80451,0,0,0-39.353,21.48955c-.73205,1.11852.8692,2.47947,1.609,1.3491a46.32234,46.32234,0,0,1,21.70337-17.653,45.71447,45.71447,0,0,1,43.42754,5.76178c1.08487.79777,2.44033-.80654,1.3491-1.609Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#e6e6e6"
      />
      <path
        d="M455.09314,156.60285l-4.68386,17.4032a1.05536,1.05536,0,0,0,1.1248,1.23526l19.6013-3.13891c1.32663-.21244,1.15324-2.30579-.18378-2.09169l-19.6013,3.13891,1.1248,1.23527,4.68386-17.4032c.35174-1.30688-1.71691-1.67525-2.06582-.37884Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#e6e6e6"
      />
      <path
        d="M465.76755,389.37279a48.47175,48.47175,0,0,0,28.736,9.33846,47.80451,47.80451,0,0,0,39.353-21.48955c.73205-1.11852-.86919-2.47947-1.609-1.3491a46.32234,46.32234,0,0,1-21.70337,17.653,45.71443,45.71443,0,0,1-43.42754-5.76179c-1.08486-.79776-2.44033.80655-1.34909,1.609Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#e6e6e6"
      />
      <path
        d="M545.64826,384.535l4.68386-17.40319a1.05536,1.05536,0,0,0-1.1248-1.23526l-19.6013,3.13891c-1.32663.21244-1.15324,2.30579.18378,2.09168l19.6013-3.1389-1.12481-1.23527-4.68386,17.40319c-.35173,1.30689,1.71691,1.67526,2.06583.37884Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#e6e6e6"
      />
      <path
        d="M711.98054,192.85314h-74.902a9.07856,9.07856,0,0,1,0-18.15712h74.902a9.07856,9.07856,0,0,1,0,18.15712Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#f2f2f2"
      />
      <path
        d="M710.25893,183.77454l3.57461-3.57467a1.08542,1.08542,0,1,0-1.535-1.535l-3.57461,3.57462-3.57462-3.57462a1.08542,1.08542,0,1,0-1.535,1.535l3.57462,3.57467-3.54921,3.5492a1.08542,1.08542,0,1,0,1.535,1.535l3.5492-3.5492,3.5492,3.5492a1.08542,1.08542,0,0,0,1.535-1.535Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#fff"
      />
      <path
        d="M593.00133,467.68157a.99672.99672,0,0,1-.71484-.30078l-5.70606-5.833a.99954.99954,0,0,1,0-1.39844l5.70606-5.83252a1,1,0,1,1,1.42968,1.39844l-5.022,5.1333,5.022,5.13379a1,1,0,0,1-.71484,1.69922Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#3f3d56"
      />
      <path
        d="M602.58971,467.68157a1,1,0,0,1-.71484-1.69922l5.02148-5.13379-5.02148-5.1333a1,1,0,0,1,1.42968-1.39844l5.70557,5.83252a.99954.99954,0,0,1,0,1.39844l-5.70557,5.833A.99674.99674,0,0,1,602.58971,467.68157Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#3f3d56"
      />
      <path
        d="M621.81346,362.50586a10.67048,10.67048,0,0,1,15.38221-5.57661L731.52733,332.209l1.54789,19.43366-92.30312,20.5874a10.72829,10.72829,0,0,1-18.95864-9.72421Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#a0616a"
      />
      <path
        d="M764.03244,328.28429l0,0a20.293,20.293,0,0,0-20.533-8.347l-34.68719,6.72909s11.94141,39.97529,27.06352,39.09222c6.37337-.37218,14.43891-4.11632,21.63815-8.324A20.32783,20.32783,0,0,0,764.03244,328.28429Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#3f3d56"
      />
      <polygon
        points="429.689 594.175 420.498 594.098 416.429 557.819 429.994 557.933 429.689 594.175"
        fill="#a0616a"
      />
      <path
        d="M733.44027,755.19666l-1.71-22.83-2.4-.16-9.79-.67-3.15-.21-.06,6.57-14.68,9.96a4.1103,4.1103,0,0,0,1.13995,7.34,3.88041,3.88041,0,0,0,1.14.17l18.27.15.16-.32,3.04-6.16,1.11,6.16.06.36005,6.9.06Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#2f2e41"
      />
      <polygon
        points="526.46 587.46 517.674 590.16 502.844 556.802 515.811 552.817 526.46 587.46"
        fill="#a0616a"
      />
      <path
        d="M827.11026,725.1167l-2.34.56995-9.53,2.31006h-.01l-3.06.75,1.93,6.29-10.99,13.92a4.12478,4.12478,0,0,0,3.23,6.66,4.1552,4.1552,0,0,0,1.2-.18005l.78-.24,16.69-5.13,1.09-7.15,3.09,5.86,6.59-2.03Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#2f2e41"
      />
      <path
        d="M710.8014,431.54871l-17.54015,50.97388-.5792,4.079c-4.41958,4.19634,1.1324,5.57879-.94934,6.68543s-3.48177,4.2088-.67637,4.7631S702.90652,697.423,714.837,705.14275s19.19128,13.30355,17,2c-.88288-4.55426.36589-28.97208,2.17191-56.5079.20469-3.12074,3.43839-6.42386.63324-9.458s.34558-5.0307.5218-7.5487c2.51638-35.95681,5.42183-71.45591,5.42183-71.45591s18.59426,63.85717,23.42274,58.91383,2.91734,7.22758,4.39282,10.8645c1.233,3.03932-4.0279,9.009,3.70388,9.1006S797.995,703.21291,799.837,703.14275c3.64941-.13916,13.9082.25391,20-1,3.0084-.61921-10.3454-47.61285-21.49629-88.19285-.88925-3.23614-5.72892-3.31146-2.61631-9.5593S783.35,557.71645,784.67894,555.84676c3.5275-4.96264,4.87075-7.11978,1.39195-7.4448s-4.50662,1.58332-4.6945-3.23071-.78837-16.68506-.78837-16.68506-2.51976-46.94879-20.16591-72.88752l-1.50489-15.41182Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#2f2e41"
      />
      <path
        d="M711.60079,432.63984c-15.20068,2.20758-40.05994,15.68567-22.77577-14l18.17322-45.32712c-13.31725-10.33951-2.12829-29.44483,9.03108-48.539l25.91173-25.9117h22.51013l5.95276,22.6407,0,0a67.61075,67.61075,0,0,1,2.6196,50.4451c-3.70359,10.76307,5.39933,34.12152,3.57724,35.86487-4,3.82715-11-.83427-4,6.49644s8.40157,9.67641,5.70079,12.50356-8.70079,11.82715-8.70079,11.82715l-9.17868,16.95883Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#3f3d56"
      />
      <circle
        cx="749.29529"
        cy="269.6342"
        r="25.65389"
        transform="translate(-346.3796 147.48567) rotate(-21.25043)"
        fill="#a0616a"
      />
      <path
        d="M783.812,302.96534a41.03955,41.03955,0,0,1,6.831,16.705,17.25412,17.25412,0,0,1-9.42086,2.71941c-.11332-.437-.22664-.87407-.35607-1.31115a37.50852,37.50852,0,0,0-4.2734-9.59889,22.59492,22.59492,0,0,1-1.27883,9.48567,16.64688,16.64688,0,0,0-5.58445-1.44067,10.14612,10.14612,0,0,0-4.53244,1.0683c-1.63481-5.42261-3.14029-10.40824-4.20859-13.98561-.0324,8.96767-13.17626,16.786-27.51794,15.65292-.518-.32376,4.67808-15.07011,4.17628-15.41007-1.14931-.76075-2.26622-1.5863-3.38313-2.39565,4.69428-7.25186,9.79313-15.02161,8.91907-16.187.06471,1.44066-5.08275,8.36866-10.6834,14.90818-3.108-2.28233,14.55212-39.41536,5.82729-42.42612-.14573,1.31114-2.072,1.31114-4.419,1.036a23.9499,23.9499,0,0,0-2.73561-6.13494,14.4096,14.4096,0,0,1-.67992,5.68166,33.0902,33.0902,0,0,0-6.89559.72843,22.09772,22.09772,0,0,0-1.732-2.36334,14.0714,14.0714,0,0,1-.08092,2.73561c-2.31483.5018-4.22489,1.0845-4.5,1.554-1.81294-.66372,1.27874-3.65828.14573-5.21227-2.88134-3.88483,1.39206-9.55029,4.09526-13.56473,5.55214-8.22294,17.741-11.07187,26.36863-6.13485.38857-1.34355,2.37954-2.23382,4.93712-2.83273a13.39453,13.39453,0,0,1,3.30211-.30756c11.00716.19424,26.28771,9.27514,26.88663,20.26619.0486,1.1007.12952,2.29853.21043,3.57727.777,12.30219-.178,23.64931,8.223,32.64929,3.04317,3.25351,3.07547,18.66359,1.91006,26.59527C790.33543,315.834,788.18253,303.43483,783.812,302.96534Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#2f2e41"
      />
      <path
        d="M846.14088,740.2406a2.26934,2.26934,0,0,0,1.64468-3.93333l-.15549-.61819q.0307-.07426.06178-.14839a6.09417,6.09417,0,0,1,11.24139.04176c1.83858,4.42818,4.17942,8.86389,4.75579,13.546a18.02888,18.02888,0,0,1-.31648,6.20046,72.28145,72.28145,0,0,0,6.57515-30.02076,69.76621,69.76621,0,0,0-.43275-7.78295q-.3585-3.17781-.9947-6.31034a73.119,73.119,0,0,0-14.50012-30.98962,19.45894,19.45894,0,0,1-8.09295-8.39651,14.84318,14.84318,0,0,1-1.34992-4.05618c.394.05167,1.48556-5.94866,1.18841-6.3168.549-.83317,1.53177-1.24733,2.13143-2.06034,2.98233-4.04341,7.0912-3.33741,9.23621,2.15726,4.58224,2.31266,4.62659,6.14806,1.81495,9.83683-1.78878,2.34682-2.03456,5.52233-3.60408,8.03479.1615.2067.32944.40695.4909.61366a73.59073,73.59073,0,0,1,7.681,12.16859,30.59231,30.59231,0,0,1,1.82641-14.20959c1.74819-4.21731,5.0249-7.76915,7.91045-11.415a6.27921,6.27921,0,0,1,11.184,3.08332q.00887.08063.01731.1612-.64288.36267-1.25863.76992a3.0782,3.0782,0,0,0,1.24106,5.60174l.06277.00967a30.628,30.628,0,0,1-.80734,4.57938c3.70179,14.31579-4.29011,19.5299-15.70147,19.76412-.25191.12917-.49738.25833-.74929.38109a75.11519,75.11519,0,0,1,4.04327,19.02779,71.24459,71.24459,0,0,1-.05168,11.50323l.01939-.13563a18.82558,18.82558,0,0,1,6.4266-10.87027c4.9456-4.06264,11.93282-5.55869,17.26826-8.82426a3.533,3.533,0,0,1,5.41121,3.43709l-.02182.1426a20.67548,20.67548,0,0,0-2.31871,1.11734q-.6429.36274-1.25864.76991a3.07824,3.07824,0,0,0,1.24107,5.6018l.06282.00965c.0452.00646.084.01295.12911.01944a30.65462,30.65462,0,0,1-5.63854,8.82922c-2.31463,12.49712-12.256,13.68282-22.89022,10.04354H869.657a75.09338,75.09338,0,0,1-5.0444,14.7262H846.59244c-.06463-.20021-.12274-.40692-.18089-.60717a20.47477,20.47477,0,0,0,4.98629-.297c-1.337-1.64059-2.674-3.2941-4.011-4.93462a1.11929,1.11929,0,0,1-.084-.0969c-.67817-.8396-1.36282-1.67283-2.041-2.51245l-.00036-.001a29.99044,29.99044,0,0,1,.87876-7.63984Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#f2f2f2"
      />
      <path
        d="M644.58953,756.38355a1.18646,1.18646,0,0,0,1.19006,1.19h253.29a1.19,1.19,0,1,0,0-2.38h-253.29A1.18651,1.18651,0,0,0,644.58953,756.38355Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#ccc"
      />
      <polygon
        points="465.735 357.202 413.285 405.87 344.912 384.781 328.99 315.024 381.44 266.356 449.813 287.445 465.735 357.202"
        fill="#f2f2f2"
      />
      <path
        d="M678.1355,463.50862a10.67044,10.67044,0,0,1,5.73886-15.32241l42.40541-87.8142,15.79065,11.43321-44.23353,83.58889a10.72829,10.72829,0,0,1-19.70139,8.11451Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#a0616a"
      />
      <path
        d="M744.38692,333.09351l0,0a20.293,20.293,0,0,0-19.67519,10.20608l-17.38944,30.75856s38.16444,16.85518,47.30562,4.77641c3.85265-5.09073,6.23781-13.65709,7.70812-21.86513A20.32783,20.32783,0,0,0,744.38692,333.09351Z"
        transform="translate(-299.60025 -142.42645)"
        fill="#3f3d56"
      />
      <path
        d="M635.74677,321.69743v86.41a8.85568,8.85568,0,0,1-8.84,8.84h-66.28l.61-.78c34.87-23.28,59.58-54.34,73.73-93.48Z"
        transform="translate(-299.60025 -142.42645)"
        fill={mainColor}
      />
      <polygon
        points="56.647 242.521 38.46 274.021 74.833 274.021 56.647 242.521 38.46 274.021 74.833 274.021 56.647 242.521"
        fill="#f2f2f2"
      />
      <circle cx="194.29273" cy="330.59372" r="60.32731" fill="#f2f2f2" />
    </svg>
  );
};

export default LimitReachedIllustration;
